/*
Akhila 04/13/2023  created warning popup messages
Akhila 5/22/2023  implemented warning toast message validation on diffrent file
Sohel 05/25/2023 3075154998 Added Dialog message instead of Toast message
Prakash 06/06/2023 3075154998 Fixed button spacing issue

*/
import React from 'react';
import {Button, Typography} from '@material-ui/core';
import reusableInputStyles from '../../../../../../components/InputStyles';
function WarningErrorPopup({handleValidationClose, warningError, warningOpen, testErrors, testError}) {
  const classes = reusableInputStyles();
  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        {warningError && (
          <div className="text-center my-3">
            <Typography variant="h4"> {warningError}</Typography>
          </div>
        )}
        {warningOpen && (
          <div className="text-center my-3">
            <Typography variant="h4">
              Invalid File Format. Allowed file formats are only .CSV and .TXT
            </Typography>
          </div>
        )}
        {testErrors && (
          <div className="text-center my-3">
            <Typography variant="h4"> {testError}</Typography>
          </div>
        )}
        <div className="d-flex justify-content-center mb-1 new-standard-textfields ">
          <Button
            type="button"
            variant="outlined"
            className={`ml-1 reset-btn`}
            onClick={() => {
              handleValidationClose();
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
export default WarningErrorPopup;
